import * as yup from 'yup'

export const loginSchema = yup.object().shape({
  email: yup
    .string()
    .email('Please enter a valid email')
    .required('Please enter your email address'),
  password: yup.string().required('Please enter your password')
})

export const authCodeSchema = yup.object().shape({
  auth_code: yup
    .string()
    .required('Verification code is required')
    .matches(/^\d{6}$/, 'Verification code must be exactly 6 digits')
})

export const customerSchema = yup.object().shape({
  first_name: yup
    .string()
    .required('First name is required'),
  last_name: yup
    .string()
    .required('Last name is required'),
  trip_type: yup
    .string()
    .oneOf(['air', 'sea'], 'Please select a valid trip type')
    .required('Trip type is required')
})

// Edit Customer Schemas
export const passportSchema = yup.object().shape({
  firstName: yup.string().required('First name is required'),
  lastName: yup.string().required('Last name is required'),
  passportNumber: yup.string().required('Passport number is required'),
  country: yup.string().required('Country is required'),
  expDate: yup.date().required('Expiration date is required'),
  dob: yup.date().required('Date of birth is required')
})

export const creditCardSchema = yup.object().shape({
  firstName: yup.string().required('First name is required'),
  lastName: yup.string().required('Last name is required'),
  cardNumber: yup.string().required('Card number is required'),
  expDate: yup.date().required('Expiration date is required'),
  cardType: yup.string().required('Card type is required'),
  cvv: yup.string().required('CVV is required')
})

export const travelTypeSchema = yup.object().shape({
  air_sea_type: yup
    .string()
    .oneOf(['air', 'sea'], 'Please select a valid travel type')
    .required('Travel type is required'),
  air_sea_typeVerified: yup.boolean()
})
